import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeWhile } from 'rxjs/operators';

import { SalesRepresentativeInterface } from 'SupportApp/interfaces/sales-representative.interface';

import { SupportService } from 'SupportApp/services/support.service';

@Component({
    standalone: false,
    selector: 'ycn-support-contact-info-page',
    templateUrl: './support-contact-info-page.template.html',
})
export class SupportContactInfoPageComponent implements OnInit, OnDestroy {
    showGetInTouch: boolean = false;

    salesRep?: SalesRepresentativeInterface;

    chatEnabled: boolean = false;

    isAlive: boolean = true;

    constructor(private supportService: SupportService) {}

    ngOnInit(): void {
        this.fetchSalesRep();
        window.hsChatEnabledSubject.pipe(takeWhile(() => this.isAlive)).subscribe(() => {
            this.chatEnabled = true;
        });
    }

    ngOnDestroy(): void {
        this.isAlive = false;
    }

    fetchSalesRep(): void {
        this.supportService.getSalesRep().subscribe({
            next: (data: SalesRepresentativeInterface) => {
                this.salesRep = data;
                this.showGetInTouch = true;
            },
            error: () => {
                this.showGetInTouch = false;
            },
        });
    }
}
